import axios from 'axios';

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {

  async createCompany({ commit, dispatch, getters }, company ={}) {

    try{
      const { companyId, role, email, telephone,
        name, contactPerson, contactNumber, state, address } = company;

      const result = await axios.post('company/create',
        {
          company_id: companyId,
          role,
          email,
          telephone,
          name,
          contact_person: contactPerson,
          contact_no: contactNumber,
          state,
          address
        });

      return { success: true, message:'Created successfully', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: {message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async fetchCorporates({ commit, dispatch, getters }, pagination = {}) {

    try{

      const { page, rowsPerPage, sortBy, descending } = pagination;

      const result  = await axios.post('company/list',
        {
          where: null,
          search: null,
          strict: true,
          role: 1,
          pagination: {
            page,
            rowsPerPage,
            sortBy,
            descending
          }
        });

      return { success: true, message: 'Corporates list', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async fetchApiPartners({ commit, dispatch, getters }, pagination = {}) {

    try{

      const { page, rowsPerPage, sortBy, descending } = pagination;

      const result  = await axios.post('company/list',
        {
          where: null,
          search: null,
          strict: true,
          role: 2,
          pagination: {
            page,
            rowsPerPage,
            sortBy,
            descending
          }
        });

      return { success: true, message: 'Corporates list', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async companyDetails({ commit, dispatch, getters }, data = 0) {

    try{

      const result  = await axios.get(`company/details/${data}`);

      return { success: true, message: 'Corporates list', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async updateCompany({ commit, dispatch, getters }, company ={}) {

    try{

      const { id, companyId, role, email, telephone,
        name, contactPerson, contactNumber, state, address } = company;

      const result = await axios.put('company/update/'+id,
        {
          company_id: companyId,
          role,
          email,
          telephone,
          name,
          contact_person: contactPerson,
          contact_no: contactNumber,
          state,
          address
        });

      return { success: true, message:'Updated successfully', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: {message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async updateCompanyField({ commit, dispatch, getters }, company ={}) {

    try{

      const { id, gstNo, rocNo, panNo } = company;

      const result = await axios.put('company/docFields/'+id,
        {
          gst_no: gstNo,
          roc_no: rocNo,
          pan_no: panNo
        });

      return { success: true, message:'Updated successfully', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: {message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async changeToken({ commit, dispatch, getters }, id =0) {

    try{

      const result = await axios.patch('company/change-token/'+id);

      return { success: true, message:'Updated successfully', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: {message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async companyProducts({ commit, dispatch, getters }, id = null) {

    try{

      const result  = await axios.get('company-product/assign/'+id,);

      return { success: true, message: 'Products list', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async companyAssignProducts({ commit, dispatch, getters }, companyProduct = {}) {

    try{

      const result  = await axios.patch('company-product/assign',
        companyProduct);

      return { success: true, message: 'Products assigned successfully!', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async companyActiveProducts({ commit, dispatch, getters }, pagination = null) {

    try{

      const { id, filter, page, rowsPerPage, sortBy, descending } = pagination;

      const listObject =  {
        where: {
          column: 'company',
          value: id
        },
        search: null,
        strict: true,
        pagination: {
          page,
          rowsPerPage,
          sortBy,
          descending
        }
      };

      if(filter){
        listObject['search'] = {
          column: 'products.name',
          value: filter
        }
      }

      const result  = await axios.post('company-product/list',
        listObject);

      return { success: true, message: 'Activated products', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async discountData({ commit, dispatch, getters }, id = null){

    try{

      const result  = await axios.post('company/discounts',{
        company: id
      })

      return { success: true, message: 'Product discounts', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  },

  async assignDiscount({ commit, dispatch, getters }, datum = {}){

    try{

      const { company, products }  = datum;

      const result  = await axios.patch('company/assign-discount',{
        company,
        products
      })

      return { success: true, message: 'Product discounts', data: result.data };
    }
    catch (e){

      const { response } = e;

      const { data: { message} } = response;

      return { success: false, message: message || 'Error while operating', data: null };
    }
  }

}
